import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { deleteCircular } from '../../api/circular';

const DeleteCircularModal = ({
  modalOpenState,
  closeModalHandler,
  circularId,
  type,
  fetchNewData,
  setSuccessAlert,
  showErrorAlert,
  resetErrorAlert,
  requestError
}) => {
  const [requestLoading, setRequestLoading] = useState(false);
  const handleDelete = async () => {
    try {
      resetErrorAlert();
      setRequestLoading(true);
      const { response, error } = await deleteCircular(circularId, type);

      if (error) {
        throw new Error(
          error?.response?.data?.message || error || 'Failed to delete circular'
        );
      }

      if (!response?.success) {
        throw new Error(response?.message || 'Failed to delete circular');
      }

      setSuccessAlert(
        `Circular ${type === 'restore' ? 'restored' : 'deleted'} successfully`
      );

      closeModalHandler();
      fetchNewData();
    } catch (e) {
      showErrorAlert(
        e?.response?.data?.message || e?.message || 'Failed to delete circular'
      );
    } finally {
      setRequestLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}></ModalHeader>
        <ModalBody>
          {requestError ? (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          ) : null}
          <h4>{`Are you sure you want to ${type} this Circular?`}</h4>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={requestLoading}
            type="button"
            color="light"
            onClick={closeModalHandler}
          >
            Close
          </Button>
          <Button type="submit" color="danger" onClick={() => handleDelete()}>
            {requestLoading
              ? type === 'restore'
                ? 'Restoring ...'
                : 'Deleting...'
              : type === 'restore'
                ? 'Restore'
                : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default DeleteCircularModal;
